import React from "react";
import { Person, ExitToAppSharp, Search, PhotoCamera, Favorite, Help, History, FitnessCenter, BugReport, CloudCircle  } from "@material-ui/icons/";
import PhotoCameraFrontIcon from '@mui/icons-material/PhotoCameraFront';
import CameraEnhanceIcon from '@mui/icons-material/CameraEnhance';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import HomeIcon from '@mui/icons-material/Home';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import GroupsIcon from '@mui/icons-material/Groups';
import TelegramIcon from '@mui/icons-material/Telegram';
import ContactMailIcon from "@mui/icons-material/ContactMail";
import SignLanguageIcon from "@mui/icons-material/SignLanguage";
import HandshakeIcon from '@mui/icons-material/Handshake';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import BuildIcon from "@mui/icons-material/Build";
import { sDrawer } from "../../utils/strings";
import { pDB_user_roles } from "../../utils/parameters";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SummarizeIcon from '@mui/icons-material/Summarize';
import TranslateIcon from '@mui/icons-material/Translate';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';

import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import AbcIcon from '@mui/icons-material/Abc';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import HandymanIcon from '@mui/icons-material/Handyman';

import ListAltIcon from '@mui/icons-material/ListAlt';



export const mainListItems = [
  {
    text: "sDrawer.hub",
    icon: <HomeIcon />,
    iconPrimary: <HomeIcon color="primary" />,
    link: "/",
    roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  },
  {
    text: "sDrawer.searchBySign",
    icon: <PhotoCameraFrontIcon />,
    iconPrimary: <PhotoCameraFrontIcon color="primary" />,
    link: "/camera",
    roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  },
  // {
  //   text: "BUSCAR FS",
  //   icon: <CameraEnhanceIcon />,
  //   iconPrimary: <CameraEnhanceIcon color="primary" />,
  //   link: "/cameraFS",
  //   roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  // },
  // {
  //   text: "sDrawer.searchBySign",
  //   icon: <PhotoCameraFrontIcon />,
  //   iconPrimary: <PhotoCameraFrontIcon color="primary" />,
  //   link: "/cameraTest",
  //   roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  // },
  {
    text: "sDrawer.searchByText",
    icon: <Search />,
    iconPrimary: <Search color="primary" />,
    link: "/search",
    roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  },

  {
    text: "Dona deletreo",  
    icon: < AbcIcon />,
    iconPrimary: < AbcIcon style={{fontSize: '40px', margin: '-10px'}} color="secondary" />,
    link: "/DonateFS",
    roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  },

  // {
  //   text: "Respuesta libre",  
  //   icon: <LooksTwoIcon />,
  //   iconPrimary: <LooksTwoIcon color="primary" />,
  //   link: "/donateResponse",
  //   roles: [pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  // },


  // {
  //   text: "sDrawer.searchBySentence",  
  //   icon: <Looks3Icon />,
  //   iconPrimary: <Looks3Icon color="primary" />,
  //   link: "/interfaceResponse",
  //   roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  // },




  {
    text: "sDrawer.history",
    icon: <History />,
    iconPrimary: <History color='primary'/>,
    link: '/history',
    roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin]
  },
  {
    text: "sDrawer.favs",
    icon: <Favorite />,
    iconPrimary: <Favorite color="primary" />,
    link: "/favs",
    roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  },
  {
    text: "sDrawer.recordsRegister",
    icon: <CloudCircle />,
    iconPrimary: <CloudCircle color='primary'/>,
    link: '/recordsRegister',
    roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin]
  },
  {
    text: "sDrawer.team",
    icon: <GroupsIcon />,
    iconPrimary: <GroupsIcon color='primary'/>,
    link: '/teams',
    roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin]

    // roles: [pDB_user_roles.annotator, pDB_user_roles.admin]
    // roles: [pDB_user_roles.admin]
  },
  {
    text: "sDrawer.leaderboard",
    icon: <EmojiEventsIcon />,
    iconPrimary: <EmojiEventsIcon color='primary'/>,
    link: '/leaderboard',
    roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin]
  },

  // {
  //   text: sDrawer.collaborator,
  //   icon: <FitnessCenter />,
  //   iconPrimary: <FitnessCenter color="primary" />,
  //   link: "/submission",
  //   roles: [pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  // },

  // {
  //   text: sDrawer.collaborator,
  //   icon: <FitnessCenter />,
  //   iconPrimary: <FitnessCenter color="primary" />,
  //   link: "/collaborator",
  //   roles: [pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  // },


  // {
  //   text: "sDrawer.datasetbuilder",
  //   icon: <BuildIcon />,
  //   iconPrimary: <BuildIcon color="primary" />,
  //   link: "/datasetbuilder",
  //   roles: [pDB_user_roles.annotator, pDB_user_roles.admin],
  // },

  {
    text: "Revisión de vídeos",
    icon: <HandymanIcon />,
    iconPrimary: <HandymanIcon color="secondary" />,
    link: "/datasetbuilderSentence",
    roles: [pDB_user_roles.admin],
  },


  {
    text: "sDrawer.reportDonateSentence",
    icon: <EmojiEventsIcon />,
    iconPrimary: <SummarizeIcon color='primary'/>,
    link: '/leaderboardSentence',
    roles: [pDB_user_roles.annotator, pDB_user_roles.admin]
  },


  {
    text: "Encuesta",
    icon: <ListAltIcon />,
    iconPrimary: <ListAltIcon color='primary'/>,
    link: '/survey',
    roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin]
  },



  // {
  //   text: sDrawer.donateSign,
  //   icon: <SignLanguageIcon />,
  //   iconPrimary: <SignLanguageIcon color="primary" />,
  //   link: "/donateSign",
  //   roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  // },
  // {
  //   text: sDrawer.versusMachine,
  //   icon: <SmartToyIcon />,
  //   iconPrimary: <SmartToyIcon color="primary" />,
  //   link: "/versusMachine",
  //   roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  // }

];

export const accountListItems = [
  // {
  //   text: sDrawer.telegramBot,
  //   icon: <TelegramIcon />,
  //   iconPrimary: <TelegramIcon color='primary'/>,
  //   link: '#',
  //   roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin]
  // },
  {
    text: "sDrawer.bug",
    icon: <BugReport />,
    iconPrimary: <BugReport color="primary" />,
    link: "/bug",
    roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  },
  // {
  //   text: "sDrawer.analytics",
  //   icon: <AnalyticsIcon />,
  //   iconPrimary: <AnalyticsIcon color="primary" />,
  //   link: "/reports",
  //   roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  // },
  {
    text: "sDrawer.feedback",
    icon: <ContactMailIcon />,
    iconPrimary: <ContactMailIcon color="primary" />,
    link: "#",
    roles: [pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  },
  {
    text: "sDrawer.help",
    icon: <Help />,
    iconPrimary: <Help color="primary" />,
    link: "#",
    roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  },
  {
    text: "sDrawer.monitor",
    icon: <MonitorHeartIcon />,
    iconPrimary: <MonitorHeartIcon color="primary" />,
    link: "#",
    roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  },
  {
    text: "sDrawer.account",
    icon: <Person />,
    iconPrimary: <Person color="primary" />,
    link: "#",
    roles: [pDB_user_roles.invitated, pDB_user_roles.registered, pDB_user_roles.collaborator, pDB_user_roles.annotator, pDB_user_roles.admin],
  },
];

export const logoutItem = [
  {
    text: "sDrawer.logout",
    icon: <ExitToAppSharp />,
    iconPrimary: <ExitToAppSharp color="primary" />,
    link: {
      pathname: "/",
      state: { logout: true },
    },
  },
];
